import { render, staticRenderFns } from "./statistical-analysis-module.vue?vue&type=template&id=48ce0632&scoped=true&"
import script from "./statistical-analysis-module.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-module.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-module.scss?vue&type=style&index=0&id=48ce0632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ce0632",
  null
  
)

export default component.exports